<template>
  <div :class="`loading ${showLoading ? 'visible' : 'hidden'}`">
    <ims-spinner :size="50" color="#FFF" />
    <div class="message">
      <div
        class="loader"
        v-for="(loader, index) in $store.state.loading.loaders"
        :key="`loader-${index}`"
      >
        {{ loader.title }}
      </div>
    </div>
    <transition name="fade">
      <div
        :class="
          `problem animate zoom ${
            $store.state.loading.problem ? 'visible' : 'hidden'
          }`
        "
      >
        There might be a problem with this request. Make sure Ad Blockers are
        disabled, and you are connected to the internet.

        <div class="ims-row flex-grow">
          <ims-button
            type="solid"
            class="filler"
            color="white"
            size="sm"
            @click="reload"
          >
            Reload
          </ims-button>
          <ims-button
            style="font-size:12px"
            @click="startOver"
            type="clear"
            color="white"
            size="sm"
          >
            OR Restart
          </ims-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  methods: {
    reload() {
      location.reload();
    },
    startOver() {
      this.$store.dispatch('interact/popmenu', {
        title: 'Restart Session',
        description:
          'This will clear your browsers session data, and allow you to log in again.',
        buttons: [
          {
            title: 'Restart',
            click: () => {
              this.$store.dispatch('user/clear/everything');
            }
          }
        ]
      });
    }
  },
  watch: {
    '$store.state.loader.loaders'(loaders) {
      // if loaders is empty - force check for problems.
      if (loaders.length == 0) {
        this.$store.commit('loaders/problem/set', false);
      }
    }
  },
  computed: {
    showLoading() {
      return this.$store.state.loading.loaders.length;
    }
  }
};
</script>

<style lang="scss">
@import '../../scss/utils/variables';
.loading {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  color: #fff;
  z-index: 1041;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  .problem {
    background-color: $primary;
    position: fixed;
    bottom: 16px;

    max-width: 600px;
    min-width: 300px;
    border-radius: 10px;
    font-size: 0.8rem;
    line-height: 0.9rem;
    max-width: 200px;
    padding: 20px;
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    .ims-button {
      margin-top: 20px;
    }
  }
  .ims-spinner {
    margin: 30px 0;
  }
  &.visible {
    background-color: rgba($primary, 0.7);
  }
  &.hidden {
    opacity: 0;
    transform: scale(1.2);
    pointer-events: none;
  }
}
</style>
